/**
 * Created by Jiu Chen on 12/03/2018.
 * Description:
 *
 * ------ maintenance history ------
 * 05/24/2019 Bowen Li: changed the float menu showing
 * 06/11/2019 Marcus Zhao: add createComponent() for dynimacComponent
 * 06/26/2019 Bowen Li: hide the setting menu in ipad
 * Updated by Abner Sui on 06/27/2019
 * Reinit system config when logout
 * 06/27/2019 Daniel Wang: thread detail open in side sheet
 * 07/03/2019 Yoyo Fang: use batchIsEventTargetWithin once instead of calling isEventTargetWithin many times.
 *
 * updated by Alan Yang on 2019.7.31
 * Hides 'Get Web Plugins' on Mac.
 * 08/25/2020 Marcus Zhao : remove settimeout 500 ms and change to  _homeViewModel.getFlyIndex for remove
 *                          dynamic dialog.
 */
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2, ViewContainerRef, ComponentRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';
// Reference to a third party
import { Router, NavigationEnd } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Subscription, Observable, forkJoin, fromEvent, Subject } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as stomp from 'stompjs';
import { saveAs } from 'file-saver';
import * as JSZip from 'jszip';
// Reference to tamalelibs
import { AppConfig } from '../../tamalelibs/models/app-config.model';
import { SystemActionTypes } from '../../tamalelibs/redux/actions/system.actions';
import { DataList } from '../../tamalelibs/models/data-list.model';
import { Thread } from '../../tamalelibs/models/thread.model';
import { ThreadService } from '../../tamalelibs/services/thread.service';
import { ContactService } from '../../tamalelibs/services/contact.service';
import { EntityConfigurationConstants, ContactConfigurationConstants } from '../../tamalelibs/models/smart-reducer.model';
import { OperationType, TaskStatusFilter, Processor } from '../../tamalelibs/models/workflow.model';
import { GlobalService, GlobalActionType } from '../../tamalelibs/services/global.service';
import { workflowSetTaskStatusSelector, workflowSetTaskProcessorSelector } from '../../tamalelibs/redux/reducers/workflow-task.reducer';
import { Message, MessageOperateType, MessageType } from '../../tamalelibs/models/message.model';
import { WorkflowTaskService } from '../../tamalelibs/services/workflow-task.service';
import { WorkflowTaskActionTypes } from '../../tamalelibs/redux/actions/workflow-task.actions';
import { SAVE_CONTACT_TEMPLATE } from '../../tamalelibs/redux/contact.actions';
// Reference to tamaleweb
import { AppState } from '../../redux';
import { Logout, SessionTimeout } from '../../redux/actions/auth.actions';
import { ContextMenuConfig, ContextMenuShowAction } from '../../widgets/tam-context-menu/tam-context-menu.model';
import { UserMessages } from '../../constants/userMessages.constants';
import { EntryTypeActionTypes } from '../../redux/actions/entry-type.actions';
import { RelationshipTypeActionTypes } from '../../redux/actions/relationship-type.actions';
import { EntityTypeActionTypes } from '../../redux/actions/entity-type.actions';
import { UsersActionTypes } from '../../redux/actions/users.actions';
import { TeamsActionTypes } from '../../redux/actions/teams.actions';
import { FloatMenuService } from '../../services/float-menu.service';
import { AdhocActionTypes } from '../../redux/actions/adhoc.actions';
import { getDraftListState } from '../../redux/reducers/draft-view.reducer';
import { MarketdataActionTypes } from '../../redux/actions/marketdata.actions';
import { DataproviderActionTypes } from '../../redux/actions/dataprovider.actions';
import { lastActionSelector } from '../../redux/reducers/action-history.reducer';
import { TamDropzoneService, TamDropzoneDomSearchObject } from '../../widgets/tam-dropzone/tam-dropzone.service';
import { PiwikSetting, SystemConfig } from '../../models/global-setting';
import { take, filter, debounceTime, switchMap, catchError } from 'rxjs/operators';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { StoreQuerierService } from '../../services/store-querier.service';
import { SubChromeActionTypes } from '../../redux/actions/sub-chrome-name.action';
import { EntityDialogComponent } from '../../components/entity-dialog/entity-dialog.component';
import { OpenDynamicComponentService } from './home-open-dynamic-component';
import { EntityDialogOpenOptions } from '../../components/entity-dialog/entity-dialog.model';
import { EntityDialogService } from '../../components/entity-dialog/entity-dialog.service';
import { AppLoadService } from '../../app-load.service';
import { ThreadDetailActions } from '../../components/thread-detail/thread-detail.view-model';
import { ThreadViewActionTypes } from '../../redux/actions/thread-view.actions';
import { threadSideSheetDataSelector } from '../../redux/reducers/thread-view.reducer';
import { ThreadDetailService } from '../../services/thread-detail.service';
import { AuditTrailDialogService } from '../../components/audit-log/audit-trail/audit-trail.service';
import { LayoutService } from '../../services/layout.service';
import { MessageService } from '../../services/message.service';
import { SlideSheetService } from '../../services/slide-sheet.service';
import { ThreadSideSheetConfig } from '../../components/thread-side-sheet/thread-side-sheet.view-model';
import { BriefConfig } from '../../widgets/widgets.model';
import { SlideSheetTempService } from '../../services/slide-sheet-temp.service';
import { PrintService } from '../../services/print.service';
import { PrintActions } from '../../components/print/print.model';
import { GlobalAction } from '../../services/platform.service';
import { BottomSlideSheetService } from '../../services/bottom-slide-sheet.service';
import { BottomSlideSheetType } from '../../components/bottom-slide-sheet/bottom-slide-sheet.model';
import { ResearchScreenConfigActionType } from '../../components/research-screen/research-screen.model';
import { ResearchHelperService } from '../../services/research-helper.service';
import { ContactTemplateOpenOptions } from '../../components/contact-dialog-new/contact-dialog.model';
import { ContactTemplateService } from '../../components/contact-dialog-new/contact-template.service';
import { DialogAction } from '../../widgets/tam-dialog/tam-dialog.model';
import { DynamicComponentService } from '../../services/dynamic-component.service';
import { HomeViewModel } from './home-view.model';
import { SlideSheetActionTypes } from '../../components/slide-sheet/slide-sheet.model';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { ToastService } from '../../widgets/toast/toast.service';
import { ContactDialogComponent } from '../../components/contact-dialog/contact-dialog.component';
import { businessConstants } from '../../constants/business.constants';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { MDLTemplateActionTypes } from '../../redux/actions/mdl-template.actions';
import { WindowRef } from '../../services/window-ref';
import { FormulajsExtensionService } from '../../services/formulajs-extension.service';
import { CopyService } from '../../services/copy.service';
import { UserPasswordService } from '../../components/user-password-dialog/user-password.service';
import { FileHelperService } from '../../services/file-helper.service';
import { CommonUtilities } from '../../services/utilities/common-utilities';
import { GlobalConfigActionTypes } from '../../redux/actions/global-config.actions';
import { StorageService } from '../../services/storage.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthHelperService } from '../../services/auth-helper.service';
export const VERSION = '25';

@Component({
    selector: 'tam-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    providers: [HomeViewModel],
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('copyArea', { static: false }) copyArea;
    @ViewChild('topbar', { static: false }) topbar: ElementRef;
    @ViewChild('flyContainer', { static: false, read: ViewContainerRef }) container: ViewContainerRef;
    draftCount = 0;
    keywordSearch = '';
    userMenuConfig: ContextMenuConfig;
    threadSideSheetConfig: ThreadSideSheetConfig;
    showThreadDetailSideSheet = false;
    showFanMenu = true;
    // show float menu except the config page
    showFloatMenu = true;
    // show float menu or show float menu with draft list
    onlyShowFloatMenu = true;
    disableBuffer = false;
    instanceId = '';
    instanceIdContact = '';
    contentContainerTop: string;
    client: any; // websocket client
    currentUser: SystemUser;
    messages: Array<Message> = [];
    simpleSearchConfig: BriefConfig;
    navigationMenuConfig: BriefConfig;
    filePreviewConfig: BriefConfig;
    // meaningless only for load agm control，
    lat = 51.678418;
    lng = 7.809007;

    private _messageManageSubject$: Subject<any> = new Subject();
    private _destroySubscriptions: Array<Subscription> = [];
    private _isIPAD = false;
    private _isMac = false;
    private _slideSheetThreadId: string = null;
    private _shortcutUpCodes: Array<number> = [191, 70, 83];
    private _shortcutDownCodes: Array<number> = [78, 69, 67, 80, 191];
    private _ssoEnabled = false;
    private _lockChangeDisableBuffer = false;
    private _mqConnected = false;

    componentRef: ComponentRef<any>;
    constructor(
        private _alertWindow: AlertWindowService,
        private _authHelper: AuthHelperService,
        private _deviceService: DeviceDetectorService,
        private _fileHelperService: FileHelperService,
        private _router: Router,
        private _store: Store<AppState>,
        private _floatMenuService: FloatMenuService,
        private _formulaExt: FormulajsExtensionService,
        private _renderer2: Renderer2,
        private _appEventService: TamDropzoneService,
        private _storeQuerier: StoreQuerierService,
        private _threadService: ThreadService,
        private _contactService: ContactService,
        private _copyService: CopyService,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _entityDialogService: EntityDialogService,
        private _initService: AppLoadService,
        private _threadDetailService: ThreadDetailService,
        private _auditTrailDialogService: AuditTrailDialogService,
        private _layoutService: LayoutService,
        private _messageService: MessageService,
        private _slideSheetService: SlideSheetService,
        private _tempSlideSheet: SlideSheetTempService,
        private _printService: PrintService,
        private _researchHelper: ResearchHelperService,
        private _bottomSlideSheetService: BottomSlideSheetService,
        private _globalService: GlobalService,
        private _taskService: WorkflowTaskService,
        private _contactTemplateService: ContactTemplateService,
        private _userPasswordService: UserPasswordService,
        private _dynamicComponentService: DynamicComponentService,
        private _homeViewModel: HomeViewModel,
        private _changeDetectorRef: ChangeDetectorRef,
        private _toast: ToastService,
        private _winRef: WindowRef,
    ) {
        this._isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
        this._isMac = this._deviceService.os.indexOf('Mac') > -1;
    }

    ngOnInit() {
        this.currentUser = this._storeQuerier.getCurrentUser();
        this.simpleSearchConfig = new BriefConfig();
        this.navigationMenuConfig = new BriefConfig();
        this.filePreviewConfig = new BriefConfig();

        this._initGlobalConstantData();
        this._initThreadDetail();
        this._initSystemConfig();

        this._destroySubscriptions.push(
            fromEvent(document, 'keyup').subscribe(event => this.onKeyUp(event)),
            fromEvent(document, 'keydown').subscribe(event => this.onKeyDown(event)),

            this._layoutService.changeSubTitleTopOpen$.subscribe((res) => {
                setTimeout(
                    () => {
                        this.contentContainerTop = res;
                    }
                );
            }),
            this._openDynamicComponentService.openDialog$.subscribe((event) => {
                this.createComponent(event);
            }),
            this._openDynamicComponentService.openContactDialog$.subscribe((event) => {
                this.createContactComponent(event);
            }),

            this._appEventService.click$.pipe(
                debounceTime(0), // use workaround to handle special requirement TAM-29072. Must use SlideSheetComponent in workflow branch after merging
            ).subscribe((event) => {
                const searches: TamDropzoneDomSearchObject[] = [];

                if (this.showThreadDetailSideSheet) {
                    searches.push(new TamDropzoneDomSearchObject('thread1', 'ag-menu-option', 5)); // for dashboard
                    searches.push(new TamDropzoneDomSearchObject('thread2', 'e-appointment', 10)); // for calendar
                    searches.push(new TamDropzoneDomSearchObject('thread3', 'threaddetail-sidesheet-status', 50));
                    searches.push(new TamDropzoneDomSearchObject('thread4', 'threaddetail-sidesheet-status-alertwindow', 10));
                    searches.push(new TamDropzoneDomSearchObject('thread5', 'note-event-dialog-controls-status', 10)); // for special controls which include class named note-event-dialog-controls-status. (ex. Priority, time dropdown control)
                }
                const searchResults = this._appEventService.batchIsEventTargetWithin(event, searches);

                if (!searchResults.includes('thread1') &&
                    !searchResults.includes('thread2') &&
                    !searchResults.includes('thread3') &&
                    !searchResults.includes('thread4') &&
                    !searchResults.includes('thread5')) {
                    if (this.showThreadDetailSideSheet && !event['slideSheet']) {
                        this.showThreadDetailSideSheet = false;
                        this._slideSheetThreadId = null;
                    }
                }
            }),
            // use workaround to fix this, need to use slidesheetcomponent in workflow branch
            this._tempSlideSheet.actionSubject$.subscribe(() => {
                this.showThreadDetailSideSheet = false;
                this._slideSheetThreadId = null;
                this._closeSideSheet();
            }),

            // to control the float menu to show
            this._floatMenuService.floatMenuBottomSubject$.subscribe(data => {
                this.showFloatMenu = data;
            }),

            this._globalService.actionSubject$.subscribe(action => {
                if (action.type === GlobalActionType.DISABLE_GLOBAL_BUFFER) {
                    if (!this._lockChangeDisableBuffer) {
                        // the change of disableBuffer flag made by Setting page may cause the Expression-Changed-After-It-Has-Been-Checked-Error.
                        // trigger another round of CD to avoid it under development mode.
                        setTimeout(
                            () => this.disableBuffer = action.payload
                        );
                    }
                } else if (action.type === GlobalActionType.LOCK_DISABLE_GLOBAL_BUFFER) {
                    this._lockChangeDisableBuffer = action.payload;
                }
            }),

            // TODO: remove this dome style manipulation after refactor home layout by replacing fixed display to flex
            this._store.pipe(select(lastActionSelector)).subscribe(historyAction => {
                if (historyAction === 'SEARCH_BAR_POPUP_SHOW') {
                    this._renderer2.setStyle(this.topbar.nativeElement, 'z-index', 1);
                } else if (historyAction === 'SEARCH_BAR_POPUP_HIDE') {
                    this._renderer2.setStyle(this.topbar.nativeElement, 'z-index', 0);
                }
            }),

            this._floatMenuService.floatMenuSubject$.subscribe(
                (subjectData: any) => {
                    this.onlyShowFloatMenu = subjectData.onlyShowFloatMenu;
                    this.draftCount = subjectData.draftCount;
                    this.keywordSearch = subjectData.keywordSearch;
                }
            ),

            this._store.pipe<any>(
                select(getDraftListState)
            ).subscribe(res => this._onSubscribeDraftListItem(res)),

            this._messageService.messageSubject$.subscribe(action => this._onMessageAction(action)),

            this._messageManageSubject$.pipe(
                debounceTime(1000),
            ).subscribe(action => {
                const tempIndexes: Array<number> = [];
                this.messages.forEach((item, index) => {
                    if (item.receiveDate !== 0 && Date.now() - item.receiveDate > 10000) {
                        tempIndexes.unshift(index);
                    }
                });
                if (tempIndexes.length) {
                    tempIndexes.forEach(item => this.messages.splice(item, 1));
                }
                if (this.messages.length) {
                    this._messageManageSubject$.next('');
                }
            }),

            // TAM-32157: listen to the file preview close action
            this.filePreviewConfig.actionSubject$.subscribe(() => {
                this._toast.notify({
                    message: 'File preview timeout.',
                    style: NotificationStyles.Error
                });
                // workaround to popup a notification when there is an error in file preview
                this._changeDetectorRef.detectChanges();
                setTimeout(() => {
                    this._changeDetectorRef.detectChanges();
                }, 3000);
            }),
            // this is to get the contact template
            this._contactService.getContactTemplate(businessConstants.Contacts.Contact_Template_Id)
                .subscribe(res => this._getTemplateConfig(res)),
        );

        this._initAccountDropdown();
        this._openDynamicComponentService.feedbackSubject$.subscribe(res => {
            let index;
            this._homeViewModel.getFlyIndex().pipe(take(1)).subscribe(_res => index = _res);
            if (res === DialogAction.CloseDialog && index && index > 0) {
                // fix issue for index out of length. in angular 10 index need minus 1.
                this.container.remove(index - 1);
                this._homeViewModel.decrement();
            }
        });

        // init data for formula
        this._winRef.nativeWindow.Formula = Object.assign({}, this._formulaExt.formulajs); // must use copy
        this._winRef.nativeWindow.Formula.ISBLANK = this._formulaExt.ISBLANK;
        this._winRef.nativeWindow.Formula.DATEDIFF = this._formulaExt.DATEDIFF;
        this._winRef.nativeWindow.Formula.DATEADD = this._formulaExt.DATEADD;
        this._winRef.nativeWindow.Formula.ISERR = this._formulaExt.ISERR;
        this._winRef.nativeWindow.Formula.ISERROR = this._formulaExt.ISERROR;
        this._winRef.nativeWindow.Formula.ISLEAPYEAR = this._formulaExt.ISLEAPYEAR;
        this._winRef.nativeWindow.Formula.DAYSBETWEEN = this._formulaExt.DAYSBETWEEN;
    }

    ngAfterViewInit(): void {
        this._copyService.copyArea = this.copyArea.nativeElement;
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        if (this.componentRef) {
            this.componentRef.destroy();
        }
        if (this._mqConnected && this.client) {
            this.client.disconnect(() => {
                console.log('disconnected');
            });
        }
    }

    /**
     * create a dynimac entity-dialog component
     */
    createComponent(entityDialogOpenOptions: EntityDialogOpenOptions) {
        this.componentRef = this._dynamicComponentService.loadComponent<EntityDialogComponent>
            (this.container, EntityDialogComponent, false);
        this.componentRef.instance.id = entityDialogOpenOptions.instanceId;
        this._store.dispatch({
            type: EntityConfigurationConstants.AddActionTypeName,
            prefix: entityDialogOpenOptions.instanceId
        });
        setTimeout(() => {
            this._entityDialogService.dialogOpen$.next(entityDialogOpenOptions);
        });
    }

    createContactComponent(contactDialogOpenOptions: ContactTemplateOpenOptions) {
        this.componentRef = this._dynamicComponentService.loadComponent<ContactDialogComponent>
            (this.container, ContactDialogComponent, false);
        this.componentRef.instance.id = contactDialogOpenOptions.instanceId;
        this._store.dispatch({
            type: ContactConfigurationConstants.AddActionTypeName,
            prefix: contactDialogOpenOptions.instanceId
        });
        setTimeout(() => {
            this._contactTemplateService.dialogOpen$.next(contactDialogOpenOptions);
        });
    }

    goToHelpPage() {
        const url = this._getHelpUrl();
        this._globalService.getHelpLinkByKey(url, VERSION).pipe(take(1)).subscribe(res => window.open(res));
    }

    logout(byUser: boolean) {
        this._initService.initSsoSetting();
        if (byUser) {
            this._store.dispatch(new Logout());
        } else {
            this._store.dispatch(new SessionTimeout(UserMessages.onSessionTimeout, this._router.url));
        }
    }

    onChangePassword() {
        this._userPasswordService.dialogOpen$.next();
    }

    onShowTaskList(event) {
        // get task status from store
        let status = this._storeQuerier.queryBySelector(workflowSetTaskStatusSelector);
        if (status === null || status === undefined) {
            status = TaskStatusFilter.Ongoing;
            this._store.dispatch({
                type: WorkflowTaskActionTypes.SET_TASK_STATUS,
                payload: status
            });
        }
        // get task proecssor from store
        let processor = this._storeQuerier.queryBySelector(workflowSetTaskProcessorSelector);
        if (processor === null || processor === undefined) {
            processor = Processor.AssignedToMe;
            this._store.dispatch({
                type: WorkflowTaskActionTypes.SET_TASK_PROCESSOR,
                payload: processor
            });
        }
        this._store.dispatch({
            type: WorkflowTaskActionTypes.GET_TASK_BY_STATUS,
            payload: {
                status: status,
                processor: processor
            }
        });
        this._slideSheetService.showSlideSheetForTaskList(event);
    }

    onMessageClick(event, item, index: number) {
        if (item.type === 'task') {
            this._slideSheetService.showSlideSheetForTask(event, item.data.task, item.data.instance, item.data.processDefinition, this._taskService.getTaskEditable(item.data.task, this.currentUser));
        } else if (item.type === MessageType.QUICK_TASK) {
            this._slideSheetService.showSlideSheetForQuickTask(event, OperationType.Edit, item.data.quickTask, item.data.subTask,
                {
                    subject: this._slideSheetService.slideSheetActionSubject$,
                    action: {
                        type: SlideSheetActionTypes.TASK_LIST,
                        payload: 'AutoChange',
                    },
                }
            );
        }
        this.messages.splice(index, 1);
    }

    onMessageClose(event, item, index: number) {
        this.messages.splice(index, 1);
    }

    onMessageMouseEnter(event, item, index: number) {
        if (this.messages[index]) {
            this.messages[index].receiveDate = 0;
        }
    }

    onMessageMouseLeave(event, item, index: number) {
        if (this.messages[index]) {
            this.messages[index].receiveDate = Date.now();
        }
        this._messageManageSubject$.next('');
    }

    onUserMenuSelect(event) {
        if (event && event.payload) {
            switch (event.payload.id) {
                case 'demo':
                    this.openPage('/demo');
                    break;
                case 'downloadAddinManifestFiles':
                    this._downloadAddinManifestFiles();
                    break;
                case 'getDesktopPlugins':
                    this._getDesktopPlugins();
                    break;
                case 'keyboardShortcuts':
                    this._bottomSlideSheetService.bottomSlideSheetActionSubject$.next({ type: BottomSlideSheetType.SHOW });
                    break;
                case 'settings':
                    this._closeSideSheet();
                    this.openPage('/settings');
                    break;
                case 'changePassword':
                    this.onChangePassword();
                    break;
                case 'signout':
                    const _isWorkflowConfig = this._router.url.toLowerCase().indexOf('workflow/config') > -1;
                    if (_isWorkflowConfig) {
                        this._initService.actionSubject$.next();
                        const subscription = this._alertWindow.warn('You have unsaved changes',
                            ['Are you sure you want to leave this page?'], 'Leave', 'Stay')
                            .subscribe((result: boolean) => {
                                if (result) {
                                    this.logout(true);
                                }
                                subscription.unsubscribe();
                            });
                    } else {
                        this.logout(true);
                    }
                    break;
            }
        }
    }

    showUserContextMenu(e: MouseEvent) {
        this.userMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }

    private _initPiwik(piwik: PiwikSetting) {
        if (piwik.piwikEnable) {
            const _paq = this._winRef.nativeWindow._paq || [];
            _paq.push(['trackPageView']);
            _paq.push(['enableLinkTracking']);
            const u = piwik.piwikServer;
            _paq.push(['setTrackerUrl', u + 'matomo.php']);
            _paq.push(['setSiteId', piwik.piwikSiteId]);
            this._winRef.nativeWindow._paq = _paq;
            const d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.async = true;
            g.defer = true;
            g.src = u + 'matomo.js';
            s.parentNode.insertBefore(g, s);
        }
    }

    /**
     * initialize thread detail for side sheet
     */
    private _initThreadDetail() {
        this.threadSideSheetConfig = new ThreadSideSheetConfig();
        this.threadSideSheetConfig.dataStoreSelector = threadSideSheetDataSelector;
        this._threadDetailService.open$.subscribe(
            (data: any) => {
                if (data.threadId !== this._slideSheetThreadId) {
                    // update thread side sheet in store
                    this._store.dispatch({
                        type: ThreadViewActionTypes.GET_THREAD_SIDESHEET,
                        payload: data.threadId
                    });
                    // trigger sidesheet
                    this.threadSideSheetConfig.actions$.next({
                        type: ThreadDetailActions.LOAD_SIDE_SHEET,
                        isMaximize: data.isMaximize,
                        closeSideSheetWhenClickMiniIcon: data.closeSideSheetWhenClickMiniIcon
                    });
                    // show/hide thread detail sidesheet
                    this.showThreadDetailSideSheet = true;
                    this._slideSheetThreadId = data.threadId;
                }
            }
        );
        this._threadDetailService.close$.subscribe(
            () => {
                this.showThreadDetailSideSheet = false;
                this._slideSheetThreadId = null;
            }
        );
        this.simpleSearchConfig.feedbackSubject$.subscribe(event => {
            this._closeSideSheet();
        });
        // close thread detail sidesheet if audit trail sideseet is opened
        this._auditTrailDialogService.open$.subscribe(
            () => {
                this.showThreadDetailSideSheet = false;
                this._slideSheetThreadId = null;
            }
        );
        this.navigationMenuConfig.actionSubject$.subscribe(action => {
            this._closeSideSheet();
        });
    }

    private _initSystemConfig() {
        this._store.pipe(
            select('systemConfig'),
            filter(item => item),
            take(1),
        ).subscribe((res: SystemConfig) => {
            if (res) {
                const systemConfig: SystemConfig = SystemConfig.parse(res);
                this._initPropertyBySystemConfig(systemConfig);
            }
        });
    }

    private _initPropertyBySystemConfig(systemConfig: SystemConfig) {
        if (systemConfig) {
            try {
                this._initWebSocket(systemConfig);
                this._initPiwik(systemConfig.piwik);
            } catch (err) {
                console.error(err);
            }
        }
    }

    private _initWebSocket(systemConfig: SystemConfig) {
        let wshost = window.location.host;
        let wsurl;
        wshost = wshost + ':' + systemConfig.mq.webSocketPort;
        wsurl = systemConfig.mq.webSocketProtocol + '://' + wshost + '/stomp';

        const login = 'consumer';
        const passcode = 'Tamale2018';
        const destination = '/topic/tamaleweb';
        if (wsurl) {
            this.client = stomp.client(wsurl);
            // this allows to display debug logs directly on the web page
            this.client.debug = (str) => {
                // console.log(str);
            };
            // disable the outgoing ping in order to prevent the disconnection of the websocket, corresponding issue: TAM-35442
            // more info: please refer to https://developer.chrome.com/blog/timer-throttling-in-chrome-88/#throttling
            this.client.heartbeat.outgoing = 0;
            this.client.heartbeat.incoming = 20000;
            // the client is notified when it is connected to the server.
            const userId = this.currentUser.id;
            const headers = { ack: 'client', selector: `PublicEntity = TRUE OR IDs LIKE '%${userId}%'` };
            const onconnect = (frame) => {
                console.log('on connect');
                console.log(frame);
                this._destroySubscriptions.push(
                    this.client.subscribe(destination, (message) => {
                        this._onMessage(message);
                    }, headers),
                );
                this._mqConnected = true;
            };
            const onconnectError = (err) => {
                console.warn('can not connect, please check MQ configuration on admin');
                this._mqConnected = false;
            };
            this.client.connect(login, passcode, onconnect, onconnectError);
        }
    }

    onKeyDown(event) {
        if (!event.ctrlKey && !event.altKey && event.keyCode && this._shortcutDownCodes.indexOf(event.keyCode) > -1
            && !event.metaKey && (!event.shiftKey || (event.shiftKey && event.keyCode === 191))) {
            const ae = document.activeElement;
            if (ae) {
                if (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA') {
                    return;
                }
                if (ae.classList && ae.classList.length) {
                    const clist = ae.classList;
                    const clen = clist.length;
                    let specialKendo = false;
                    if (!specialKendo) {
                        for (let i = 0; i < clen; i++) {
                            // If is kendoTree, enable shortcuts
                            if (clist[i].startsWith('k-treeview')) {
                                specialKendo = true;
                                break;
                            }
                        }
                    }
                    if (!specialKendo) {
                        for (let i = 0; i < clen; i++) {
                            // If is kendo or frola, no shortcuts
                            if (clist[i].startsWith('k-') || clist[i].startsWith('fr-')) {
                                return;
                            }
                        }
                    }
                }
            }
            const dialogs: any = document.getElementsByTagName('kendo-dialog');
            if (dialogs && dialogs.length) {
                for (let i = 0; i < dialogs.length; i++) {
                    if (dialogs[i].style && dialogs[i].style.visibility !== 'hidden') {
                        return;
                    }
                }
            }
            switch (event.keyCode) {
                // N
                case 78:
                    if (this.showFloatMenu) {
                        this.topbar.nativeElement.click();
                        this._tempSlideSheet.actionSubject$.next('');
                        this._floatMenuService.showAddNoteDialog();
                    }
                    break;
                // E
                case 69:
                    if (this.showFloatMenu) {
                        this.topbar.nativeElement.click();
                        this._tempSlideSheet.actionSubject$.next('');
                        this._floatMenuService.showAddEntityDialog();
                    }
                    break;
                // C
                case 67:
                    if (this.showFloatMenu) {
                        this.topbar.nativeElement.click();
                        this._tempSlideSheet.actionSubject$.next('');
                        this._floatMenuService.showAddContactDialog();
                    }
                    break;
                // P
                case 80:
                    this.topbar.nativeElement.click();
                    this._tempSlideSheet.actionSubject$.next('');
                    this._printService.actionSubject$.next({ type: PrintActions.PRINT });
                    break;
                // / or ?
                case 191:
                    if (event.shiftKey) { // ?
                        const bss: any = document.getElementById('bottom-slide-sheet');
                        if (bss && bss.classList && bss.classList.length) {
                            if (bss.classList.value.indexOf('container-show') > -1) {
                                this.topbar.nativeElement.click();
                            } else {
                                this.topbar.nativeElement.click();
                                this._bottomSlideSheetService.bottomSlideSheetActionSubject$.next({ type: BottomSlideSheetType.SHOW });
                            }
                        }
                    }
                    break;
                // R
                case 82:
                    break;
                default:
                    break;
            }
        }
    }

    onKeyUp(event) {
        if (!event.ctrlKey && !event.altKey && event.keyCode && this._shortcutUpCodes.indexOf(event.keyCode) > -1
            && !event.shiftKey && !event.metaKey) {
            const ae = document.activeElement;
            if (ae) {
                if (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA') {
                    return;
                }
                if (ae.classList && ae.classList.length) {
                    const clist = ae.classList;
                    const clen = clist.length;
                    let specialKendo = false;
                    if (!specialKendo) {
                        for (let i = 0; i < clen; i++) {
                            // If is kendoTree, enable shortcuts
                            if (clist[i].startsWith('k-treeview')) {
                                specialKendo = true;
                                break;
                            }
                        }
                    }
                    if (!specialKendo) {
                        for (let i = 0; i < clen; i++) {
                            // If is kendo or frola, no shortcuts
                            if (clist[i].startsWith('k-') || clist[i].startsWith('fr-')) {
                                return;
                            }
                        }
                    }
                }
            }
            const dialogs: any = document.getElementsByTagName('kendo-dialog');
            if (dialogs && dialogs.length) {
                for (let i = 0; i < dialogs.length; i++) {
                    if (dialogs[i].style && dialogs[i].style.visibility !== 'hidden') {
                        return;
                    }
                }
            }
            switch (event.keyCode) {
                // s, same as /
                case 83:
                // /
                case 191:
                    this.topbar.nativeElement.click();
                    this._tempSlideSheet.actionSubject$.next('');
                    this.simpleSearchConfig.actionSubject$.next({ type: GlobalAction.FOCUS });
                    break;
                // F
                case 70:
                    this.topbar.nativeElement.click();
                    this._tempSlideSheet.actionSubject$.next('');
                    this._researchHelper.researchActionSubject$.next({ type: ResearchScreenConfigActionType.FOCUS_FINDER });
                    break;
                default:
                    break;
            }
        }
    }

    openPage(routeUrl) {
        this._router.navigate([routeUrl]);
    }

    showContextMenu(e: MouseEvent) {
        this.userMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }

    private _changePositionOfNewNoteMinimizePanel() {
        if (this.onlyShowFloatMenu) {
            this._floatMenuService.floatMenuSubject$.next({
                onlyShowFloatMenu: true,
                draftCount: this.draftCount
            });
        }
    }

    private _closeSideSheet(): void {
        if (this.threadSideSheetConfig) {
            this.threadSideSheetConfig.actions$.next({
                type: 'CLOSE_SIDESHEET'
            });
        }
    }

    private _downloadAddinManifestFiles() {
        if (!CommonUtilities.validateIPAddress(window.location.host)) {
            const zip = new JSZip();
            this._fileHelperService.getAddinManifestFiles().pipe(
                take(1)
            ).subscribe(OfficeAddInManifest => {
                OfficeAddInManifest.files.forEach(file => {
                    if (file && file.fileName) {
                        zip.file(file.fileName, file.jsonContent);
                    }
                });
                zip.generateAsync({ type: 'blob' })
                    .then(function (content) {
                        saveAs(content, businessConstants.officeAddIn.manifestFileZipName);
                    });
            });
        } else {
            this._toast.notify({
                message: businessConstants.officeAddIn.downloadManifestError,
                style: NotificationStyles.Error
            });
        }
    }

    private _getDesktopPlugins() {
        const _hashtime = new Date().getTime();
        const url = '../installer/Advent.Tamale.NextGen.Plugins.Setup.msi?version=' + _hashtime;
        window.open(url, '_blank');
    }

    private _getHelpUrl() {
        const url = this._router.url;
        let mappingKey = businessConstants.helpKeyContainer.default;
        Object.keys(businessConstants.helpKeyContainer).forEach(key => {
            if (url.includes(key)) {
                mappingKey = businessConstants.helpKeyContainer[key];
            }
        });
        return mappingKey;
    }

    private _getTemplateConfig(res) {
        const templateSettings = this._contactService.getTemplateConfig(res);
        this._store.dispatch({
            type: SAVE_CONTACT_TEMPLATE,
            payload: templateSettings
        });
    }

    private _initAccountDropdown() {
        this.userMenuConfig = new ContextMenuConfig();
        this.userMenuConfig.stateful = false;
        this.userMenuConfig.showItemIcon = false;
        const username = AppConfig.username;
        this.userMenuConfig.showItemIcon = true;
        const ssoSetting = this._authHelper.getSsoSettings();

        this.userMenuConfig.items = [
            {
                text: username,
                hidden: true // web 1.0 used to show user name
            },
            {
                id: 'downloadAddinManifestFiles',
                text: 'Download Office Addin Manifest Files',
                icon: 'download',
                hidden: this._isIPAD,
            },
            {
                id: 'getDesktopPlugins',
                text: 'Get Web Plugins',
                icon: 'download',
                hidden: this._isIPAD || this._isMac,
            }, {
                id: 'keyboardShortcuts',
                text: 'Keyboard Shortcuts',
                icon: 'shortcut'
            },
            {
                id: 'settings',
                text: 'Settings',
                icon: 'cog',
                hidden: this._isIPAD
            },
            {
                divider: true
            },
            {
                id: 'changePassword',
                text: 'Change password',
                icon: 'userpassword-change',
                hidden: ssoSetting.ssoEnabled
            },
            {
                id: 'signout',
                text: 'Log Out',
                icon: 'sign-out'
            }
        ];
        this._destroySubscriptions.push(
            this.userMenuConfig.events$.subscribe(event => this.onUserMenuSelect(event)),
        );
    }

    private _initGlobalConstantData() {
        this._store.dispatch({
            type: EntryTypeActionTypes.INITIALIZE
        });
        this._store.dispatch({
            type: RelationshipTypeActionTypes.INITIALIZE
        });
        this._store.dispatch({
            type: EntityTypeActionTypes.INITIALIZE
        });
        this._store.dispatch({
            type: UsersActionTypes.INITIALIZE
        });
        this._store.dispatch({
            type: UsersActionTypes.LOAD_USER_SETTING
        });
        this._store.dispatch({
            type: TeamsActionTypes.INITIALIZE
        });
        this._store.dispatch({
            type: SystemActionTypes.GET_SCREENS
        });
        this._store.dispatch({
            type: AdhocActionTypes.INITIALIZE
        });
        this._store.dispatch({
            type: MarketdataActionTypes.INITIALIZE
        });
        this._store.dispatch({
            type: DataproviderActionTypes.INITIALIZE
        });
        // init the liveware's value
        this._store.dispatch({
            type: SubChromeActionTypes.GET_LIVEWIRE_SUBCHORME_NAME
        });
        this._store.dispatch({
            type: RelationshipTypeActionTypes.GETVALIDRELATIONSHIP
        });
        this._store.dispatch({
            type: SystemActionTypes.GET_UNCATEGORUZEEID
        });
        this._store.dispatch({
            type: MDLTemplateActionTypes.INITIALIZE
        });
    }

    private _onMessage(message) {
        const body: string = message.body;
        if (body && body.indexOf('{') === 0 && body.lastIndexOf('}') === body.length - 1) {
            const action: { type: string, payload: any } = JSON.parse(body);
            this._messageService.parseMessage(action, this.messages);
        }
        this._messageManageSubject$.next('');
    }

    private _onMessageAction(action) {
        if (action.type === MessageOperateType.DELETE) {
            const index = this.messages.findIndex(item => item.id === action.payload.id);
            if (index > -1) {
                this.messages.splice(index, 1);
            }
        }
    }

    // the distance between float menu and minimized new note panel should be 16px
    // so the draft count and the information of showing float menu or float menu with draft list should be send tou to tam-dialog to change the position
    private _onSubscribeDraftListItem(items: DataList<Thread>) {
        if (items) {
            this.draftCount = items.length;
            this._changePositionOfNewNoteMinimizePanel();
        }
    }
}

